<template>
  <family-page-wrapper>
    <div class="coming-soon-message">
      Coming Soon...
    </div>
  </family-page-wrapper>
</template>
